import script from "./IntroPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroPopup.vue?vue&type=script&setup=true&lang=js"

import "./IntroPopup.vue?vue&type=style&index=0&id=242bf2a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242bf2a0"]])

export default __exports__